import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
class ProBonoLegalHelp extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
  window.menu_selection('/pro_bono_begal_help');
}


  toggle_info(id){
    if($("#"+id).hasClass("hide")){
      $("#"+id+"_i").text("Read Less...");
    }else {
      $("#"+id+"_i").text("Read More...")
    }
    $('#'+id).toggleClass('hide');
  }


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="Insights"/>
          <div class="container-xxl mt-5 inner_con_grey">
          <div className="container inner_con ">
              <div className="row g-4 mb-2">
                <h1 className="text-start mb-3 wow fadeInUp title_view" data-wow-delay="0.1s">Pro-Bono Legal Help</h1>
                      <div className="col-lg-12 wow fadeIn about-img-div-margin-top padding_left_zero" data-wow-delay="0.1s">
                          <div className="row g-0 about-bg rounded overflow-hidden">
                              <div className="col-12 text-start">
                                  <img className="img-fluid w-100" alt="Pro_bono" src="/assets/img/pro_bono/pro_bono.png"/>
                              </div>

                          </div>
                      </div>
                      <div className="col-lg-12 wow fadeIn about-info-div-home padding_left_zero" data-wow-delay="0.5s">
                        <h3 className=''>Pro Bono & Social Responsibility</h3>
                        <p className="mb-2">At <b>BYLAWS Legal LLP</b>, access to justice forms an essential component of ethical legal practice. While the Firm primarily advises on complex corporate, regulatory, compliance, and governance matters, we consciously allocate professional time and institutional resources toward carefully selected pro bono engagements that advance legitimate social and public-interest objectives.</p>
                        <p className="mb-2">We believe that high-quality legal representation should not be inaccessible due to financial constraints where genuine legal rights require protection. Our pro bono initiatives are therefore structured, merit-based, and aligned with professional conduct standards.</p>
                        <p className="mb-2"><b>Scope of Pro Bono Engagement</b></p>
                        <p className="mb-2">The Firm may extend pro bono assistance in matters such as:</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Legal support to economically disadvantaged individuals in civil or governance-related matters</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Advisory to NGOs, public trusts, and charitable institutions on compliance, structuring, and regulatory matters</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Women, child, and senior citizen protection issues</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Institutional governance strengthening for social sector organisations</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Legal awareness and compliance literacy initiatives</p>
                        <p className="mb-2">We do not undertake matters that present conflicts of interest, reputational exposure inconsistent with professional ethics, or cases lacking legal merit.</p>
                        <p className="mb-2">Pro bono representation does not create an ongoing or indefinite client relationship beyond the agreed mandate.</p>
                        <p className="mb-2"><b>How to Request Pro Bono Assistance</b></p>
                        <p className="mb-2">Requests may be submitted through our official contact channels with:</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>A brief summary of facts and relief sought</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Relevant supporting documentation</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Disclosure of financial hardship or institutional need</p>
                        <p className="mb-2 ms-3"><i class="fa fa-circle  me-2 text-10size"></i>Confirmation regarding existing legal representation</p>
                        <p className="mb-2">Each request is reviewed confidentially and independently. Acceptance is subject to merit, resource availability, regulatory compliance considerations, and internal approval.</p>




                      </div>
                  </div>
              </div>
       </div>
      <Footer />
    </div>
    );
  }
}

export default ProBonoLegalHelp;
